export enum ELandingLoanTermsAnimationDelay {
  TITLE = 0,
  LIST = 500,
}
